export const DATE_FORMATS = {
    af: 'YYYY/MM/DD',
    am: 'D/M/YYYY',
    ar: 'DD/MM/YYYY',
    az: 'DD.MM.YYYY',
    be: 'DD.MM.YYYY',
    bg: 'DD.M.YYYY',
    bn: 'DD-MM-YY',
    bs: 'D.M.YYYY',
    ca: 'DD/MM/YYYY',
    co: 'DD/MM/YYYY',
    cs: 'D.M.YYYY',
    cy: 'DD/MM/YYYY',
    da: 'DD-MM-YYYY',
    de: 'DD.MM.YYYY',
    el: 'D/M/YYYY',
    en: 'M/D/YYYY',
    es: 'DD/MM/YYYY',
    et: 'D.MM.YYYY',
    eu: 'YYYY/MM/DD',
    fa: 'MM/DD/YYYY',
    fi: 'D.M.YYYY',
    fr: 'DD/MM/YYYY',
    fy: 'D-M-YYYY',
    ga: 'DD/MM/YYYY',
    gd: 'DD/MM/YYYY',
    gl: 'DD/MM/YY',
    gu: 'DD-MM-YY',
    ha: 'D/M/YYYY',
    he: 'DD/MM/YYYY',
    hi: 'DD-MM-YYYY',
    hr: 'D.M.YYYY',
    hu: 'YYYY. MM. DD.',
    hy: 'DD.MM.YYYY',
    id: 'DD/MM/YYYY',
    ig: 'D/M/YYYY',
    is: 'D.M.YYYY',
    it: 'DD/MM/YYYY',
    ja: 'YYYY/MM/DD',
    ka: 'DD.MM.YYYY',
    kk: 'DD.MM.YYYY',
    km: 'YYYY-MM-DD',
    kn: 'DD-MM-YY',
    ko: 'YYYY-MM-DD',
    ky: 'DD.MM.YY',
    lb: 'DD/MM/YYYY',
    lo: 'DD/MM/YYYY',
    lt: 'YYYY.MM.DD',
    lv: 'YYYY.MM.DD.',
    mi: 'DD/MM/YYYY',
    mk: 'DD.MM.YYYY',
    ml: 'DD-MM-YY',
    mn: 'YY.MM.DD',
    mr: 'DD-MM-YYYY',
    ms: 'DD/MM/YYYY',
    mt: 'DD/MM/YYYY',
    no: 'DD.MM.YYYY',
    ne: 'M/D/YYYY',
    nl: 'D-M-YYYY',
    or: 'DD-MM-YY',
    pa: 'DD-MM-YY',
    pl: 'YYYY-MM-DD',
    ps: 'DD/MM/YY',
    pt: 'D/M/YYYY',
    ro: 'DD.MM.YYYY',
    ru: 'DD.MM.YYYY',
    rw: 'M/D/YYYY',
    si: 'YYYY-MM-DD',
    sk: 'D. M. YYYY',
    sl: 'D.M.YYYY',
    sn: 'D.M.YYYY',
    sq: 'YYYY-MM-DD',
    sr: 'D.M.YYYY',
    sv: 'D.M.YYYY',
    sw: 'M/D/YYYY',
    ta: 'DD-MM-YYYY',
    te: 'DD-MM-YY',
    tg: 'DD.MM.YY',
    th: 'D/M/YYYY',
    tk: 'DD.MM.YY',
    tr: 'DD.MM.YYYY',
    tt: 'DD.MM.YYYY',
    ug: 'YYYY-M-d',
    uk: 'DD.MM.YYYY',
    ur: 'DD/MM/YYYY',
    uz: 'DD/MM YYYY',
    vi: 'DD/MM/YYYY',
    xh: 'YYYY/MM/DD',
    yo: 'D/M/YYYY',
    zh: 'D/M/YYYY',
    zu: 'YYYY/MM/DD',
};
